import { ChartTypes, DataProfilingTypes, SortSettingsTypes } from '@mode/shared/contract-common';
import { RowHeight, VizTypes } from '../report-sandbox.types';
import { EmbedReportActions } from '../viewer/embed-report.actions';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace EmbedBuilderActions {
  export enum Type {
    CloseHeightMenu = 'builder.closeHeightMenu',
    CloseMoveMenu = 'builder.closeMoveMenu',
    CloseSettingsMenu = 'builder.closeSettingsMenu',
    ToggleHeightMenu = 'builder.toggleHeightMenu',
    ToggleMoveMenu = 'builder.toggleMoveMenu',
    ToggleSettingsMenu = 'builder.toggleSettingsMenu',
    SelectViz = 'builder.selectViz',
    SetRowHeight = 'builder.setRowHeight',
    SetFullTable = 'builder.setFullTable',
    SetAutoTable = 'builder.setAutoTable',
    ToggleTextMargin = 'builder.toggleTextMargin',

    EditViz = 'builder.editViz',
    EditText = 'builder.editText',
    UpdateText = 'builder.updateText',
    CloneViz = 'builder.cloneViz',
    RemoveViz = 'builder.removeViz',

    UpdateTitle = 'builder.updateTitle',
    UpdateCaptionInfo = 'builder.updateCaptionInfo',
    UpdateV1View = 'builder.updateV1View',
    UpdateBigValueDescription = 'builder.updateBigValueDescription',
    UpdateFormat = 'builder.updateFormat',

    AddChart = 'builder.addChart',
    CreateChart = 'builder.createChart',
    AddTable = 'builder.addTable',
    AddText = 'builder.addText',

    ResizeGridElement = 'builder.resizeGridElement',
    MoveGridElement = 'builder.moveGridElement',

    LoadThemeSuccess = 'builder.loadThemeSuccess',

    SelectQuery = 'builder.selectQuery',

    GetDataProfiling = 'builder.getDataProfiling',

    UpdateSortSettings = 'builder.updateSortSettings',
  }

  export class EditViz {
    readonly type = Type.EditViz;

    constructor(
      public readonly token: string,
      public readonly queryToken: string,
      public readonly vizType: VizTypes
    ) {}
  }

  export class EditText {
    readonly type = Type.EditText;

    constructor(public readonly token: string) {}
  }

  export class RemoveViz {
    readonly type = Type.RemoveViz;

    constructor(
      public readonly token: string,
      public readonly vizType: VizTypes
    ) {}
  }

  export class CloneViz {
    readonly type = Type.CloneViz;

    constructor(
      public readonly token: string,
      public readonly vizType: VizTypes,
      public readonly position: number
    ) {}
  }

  export class CloseHeightMenu {
    readonly type = Type.CloseHeightMenu;
  }
  export class CloseMoveMenu {
    readonly type = Type.CloseMoveMenu;
  }

  export class CloseSettingsMenu {
    readonly type = Type.CloseSettingsMenu;
  }

  export class ToggleHeightMenu {
    readonly type = Type.ToggleHeightMenu;
  }

  export class ToggleMoveMenu {
    readonly type = Type.ToggleMoveMenu;
  }

  export class ToggleSettingsMenu {
    readonly type = Type.ToggleSettingsMenu;
  }

  export class SelectViz {
    readonly type = Type.SelectViz;
    constructor(
      public readonly token: string,
      public readonly vizType: VizTypes
    ) {}
  }

  export class SetRowHeight {
    readonly type = Type.SetRowHeight;

    constructor(
      public readonly token: string,
      public readonly vizType: VizTypes,
      public readonly height: RowHeight
    ) {}
  }

  export class SetFullTable {
    readonly type = Type.SetFullTable;

    constructor(public readonly token: string) {}
  }

  export class SetAutoTable {
    readonly type = Type.SetAutoTable;

    constructor(public readonly token: string) {}
  }

  export class ToggleTextMargin {
    readonly type = Type.ToggleTextMargin;

    constructor(public readonly token: string) {}
  }

  export class UpdateTitle {
    readonly type = Type.UpdateTitle;

    constructor(
      public readonly token: string,
      public readonly vizType: VizTypes,
      public readonly title: string
    ) {}
  }

  export class UpdateCaptionInfo {
    readonly type = Type.UpdateCaptionInfo;

    constructor(
      public readonly token: string,
      public readonly vizType: VizTypes,
      public readonly captionInfo: ChartTypes.CaptionInfo
    ) {}
  }

  export class UpdateBigValueDescription {
    readonly type = Type.UpdateBigValueDescription;

    constructor(
      public readonly token: string,
      public readonly vizType: VizTypes,
      public readonly description: string
    ) {}
  }

  export class UpdateFormat {
    readonly type = Type.UpdateFormat;

    constructor(
      public readonly token: string,
      public readonly format: ChartTypes.ChartFormat
    ) {}
  }

  export class AddChart {
    readonly type = Type.AddChart;

    constructor(
      public readonly token: string,
      public readonly position: number
    ) {}
  }

  export class CreateChart {
    readonly type = Type.CreateChart;

    constructor(
      public readonly queryToken: string,
      public readonly position: number
    ) {}
  }

  export class AddTable {
    readonly type = Type.AddTable;

    constructor(
      public readonly token: string,
      public readonly position: number
    ) {}
  }

  export class AddText {
    readonly type = Type.AddText;

    constructor(public readonly position: number) {}
  }

  export class UpdateText {
    readonly type = Type.UpdateText;

    constructor(
      public readonly token: string,
      public readonly text: string
    ) {}
  }

  export class UpdateV1View {
    readonly type = Type.UpdateV1View;

    constructor(
      public readonly vizType: VizTypes,
      public readonly token: string,
      public readonly view: ChartTypes.ChartView
    ) {}
  }

  export class ResizeGridElement {
    readonly type = Type.ResizeGridElement;

    constructor(
      public readonly id: string,
      public readonly direction: string,
      public readonly columnSize: number
    ) {}
  }

  export class MoveGridElement {
    readonly type = Type.MoveGridElement;

    constructor(
      public readonly id: string,
      public readonly row: number,
      public readonly column: number
    ) {}
  }

  export class LoadThemeSuccess {
    readonly type = Type.LoadThemeSuccess;
  }

  export class SelectQuery {
    readonly type = Type.SelectQuery;
    constructor(public readonly queryToken: string) {}
  }

  export class GetDataProfiling {
    readonly type = Type.GetDataProfiling;

    constructor(
      public token: string,
      public cols: DataProfilingTypes.DataProfilingColInfo[],
      public referenceId: string
    ) {}
  }

  export class UpdateSortSettings {
    readonly type = Type.UpdateSortSettings;

    constructor(
      public token: string,
      public event: SortSettingsTypes.SortSettingsEvent
    ) {}
  }

  export type Actions =
    | ToggleHeightMenu
    | CloseHeightMenu
    | ToggleMoveMenu
    | CloseMoveMenu
    | ToggleSettingsMenu
    | CloseSettingsMenu
    | SelectViz
    | CloneViz
    | UpdateText
    | EditViz
    | EditText
    | RemoveViz
    | SetRowHeight
    | SetFullTable
    | SetAutoTable
    | ToggleTextMargin
    | UpdateTitle
    | UpdateCaptionInfo
    | UpdateBigValueDescription
    | UpdateV1View
    | AddChart
    | CreateChart
    | AddTable
    | AddText
    | ResizeGridElement
    | MoveGridElement
    | LoadThemeSuccess
    | SelectQuery
    | UpdateFormat
    | GetDataProfiling
    | UpdateSortSettings
    | EmbedReportActions.Actions; // builder depends on report actions as well
}
